export function hasValue(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=has-value.js.map